import { DarkMode, LightMode, Settings, Event as EventIcon } from "@mui/icons-material";
import { Logout } from "@mui/icons-material";

import {
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Avatar,
    Divider,
    Switch,
    useMediaQuery,
} from "@mui/material";

const DesktopNavbarIcons = ({
    anchorEl,
    open,
    handleProfileMenuClose,
    isTabletUp,
    profilePhoto,
    navigateToProfile,
    toggleDarkMode,
    isDarkMode,
    navigate,
    handleLogout,
}: {
    anchorEl: HTMLElement | null;
    open: boolean;
    handleProfileMenuClose: () => void;
    isTabletUp: boolean;
    profilePhoto: string;
    navigateToProfile: () => void;
    toggleDarkMode: () => void;
    isDarkMode: boolean;
    navigate: (path: string) => void;
    handleLogout: () => void;
}) => {
    const isMobile = useMediaQuery("(max-width:900px)");

    return (
        <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleProfileMenuClose}
            PaperProps={{
                elevation: 0,
                sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                    },
                    "&:before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                    },
                    zIndex: 1200,
                },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            {...(!isTabletUp && {
                anchorOrigin: { horizontal: "center", vertical: "top" },
                transformOrigin: { horizontal: "center", vertical: "bottom" },
            })}
        >
            {/* My Profile */}
            <MenuItem onClick={navigateToProfile}>
                <Avatar src={profilePhoto} /> My Profile
            </MenuItem>

            {/* Events - ahow only on mobile */}
            {isMobile && (
                <MenuItem
                    onClick={() => {
                        handleProfileMenuClose();
                        navigate("/events");
                    }}
                >
                    <EventIcon sx={{ mr: 1 }} /> Events
                </MenuItem>
            )}

            {/* Dark Mode and Light Mode toggle */}
            <MenuItem
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <ListItemIcon sx={{ minWidth: "auto", marginRight: 0 }}>
                    {isDarkMode ? <LightMode fontSize="small" /> : <DarkMode fontSize="small" />}
                </ListItemIcon>
                <ListItemText primary={isDarkMode ? "Light Mode" : "Dark Mode"} />
                <Switch
                    edge="end"
                    onChange={toggleDarkMode}
                    checked={isDarkMode}
                    onClick={(e) => e.stopPropagation()}
                    inputProps={{
                        "aria-label": "toggle dark mode switch",
                    }}
                />
            </MenuItem>

            {/* Settings */}
            <MenuItem
                onClick={() => {
                    handleProfileMenuClose();
                    navigate("/settings");
                }}
            >
                <Settings sx={{ mr: 1 }} /> Settings
            </MenuItem>

            {/* Divider line on top of "Logout" */}
            <Divider />

            {/* Logout */}
            <MenuItem onClick={handleLogout}>
                <Logout sx={{ mr: 1 }} /> Logout
            </MenuItem>
        </Menu>
    );
};

export default DesktopNavbarIcons;
